import { tooltip } from "../../config/datatable";
import { ellipsis } from "../";

/**
 * Updates the column model with tooltips whenever the column name exceeds a
 * preconfigured length.
 *
 * @param {Array} columns
 */
const tooltipConfigurator = (columns = []) => {
  return columns.map((c) => {
    // copy original name
    c.nameOriginal = c.name;

    // nullify falsy tooltips
    c.tooltip = _.isEmpty(c.tooltip) ? null : c.tooltip;

    // when null, update tooltip with original name
    if (null === c.tooltip) {
      c.tooltip = c.name;
    }

    // shorten name
    const shortName = c.name
      .trim() // trim outer spaces
      .replace(/[^A-Za-z0-9#%+]+/g, " ") // swap invalid chars for spaces
      .replace(/\s\s+/g, " ") // collapse multiple spaces into one
      .split(" ")
      .slice(0, tooltip.maxWordCount)
      .join(" ");

    // trim display name
    c.name = ellipsis(shortName, tooltip.maxLength);

    return c;
  });
};

export { tooltipConfigurator as default };
